import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_DOMAIN_PREBID_STACK: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateDomainPrebidStack($input: UpdateDomainPrebidStackInput!) {
    updateDomainPrebidStack(input: $input) {
      domainPrebidStack {
        id
        allowActivitiesData
        auctionDelay
        customAuctionDelayEnabled
        customConsentManagementEnabled
        customizeAllowActivities
        customPrebidConfigEnabled
        customPrebidTimeoutEnabled
        domainAmazonEnabled
        domainId
        gdprTcfTimeout
        gdprTcfEnabled
        gppControlUsNat
        gppControlUsStates
        gppTimeout
        gppEnabled
        prebidCustomConfig
        prebidStackEnabled
        prebidTimeout
        syncDelay
        syncDelayEnabled
        syncsPerBidder
        syncsPerBidderEnabled
        usPrivacyCcpaTimeout
        usPrivacyCcpaEnabled
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
